/* eslint-disable jsx-a11y/no-autofocus */

import React, { useState, useRef } from "react";
import Flink from '~/components/shared/flink'
import { Seo } from '~/components/shared/seo'
import useShopCustomerHook from '~/utils/use-customer'

import { field, field_submit, errors, submit_opts, label_small } from "~/styles/app.module.scss"

import * as styles from "~/styles/account/logreg.module.scss"

const AcctRegister = () => {
  const { register } = useShopCustomerHook()

  const [error, setError] = useState(false)
  const firstRef = useRef(null)
  const lastRef = useRef(null)
  const emailRef = useRef(null)
  const passRef = useRef(null)
  const marketRef = useRef(null)

  const is_stag = process.env.GATSBY_CURR_ENV === 'development'
  const auth_url = is_stag ? 'https://buckmason-rms.pima.io/auth' : 'https://orders.buckmason.com/auth'

  const handleRegister = async () => {
    const first = firstRef.current.value
    const last = lastRef.current.value
    const email = emailRef.current.value
    const pass = passRef.current.value
    const marketing = marketRef.current.checked

    const empty = !first || !last || !email || !pass
    
    if (empty) {
      setError(true)
      return
    }

    const obj = {input: {
      firstName: first, 
      lastName: last, 
      email: email, 
      password: pass, 
      acceptsMarketing: marketing
    }}

    const trylogin = await register(obj)
    if (trylogin !== true) setError(true)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    handleRegister()
  }

  return (
    <div className={styles.logreg}>
      <div className={styles.wrap}>
        <form onSubmit={(e)=>handleSubmit(e)} >

          <h1 className={styles.title}>CREATE ACCOUNT</h1>

          <div className={errors} aria-hidden={error ? 'false' : 'true'} role="alert" aria-atomic="true">
            <strong>Unable to register</strong>
            There was a problem, please try again or if you are still unable to create an
            account, please <Flink href={'/pages/faq'}>contact us</Flink>.
          </div>
          
          <div className={field}>
            <input 
              id={'FirstName'}
              type="text" 
              ref={firstRef}
              name="customer[first_name]"
              className={styles.input}
              placeholder="First Name" 
              required="required"
            />
            <label 
              htmlFor="FirstName" 
              className={[label_small, styles.label].join(' ')} 
              aria-hidden={"true"}
            >
              First Name
            </label>
          </div>

          <div className={field}>
            <input 
              id={'LastName'}
              type="text" 
              ref={lastRef}
              name="customer[last_name]"
              className={styles.input}
              placeholder="Last Name" 
              required="required"
            />
            <label 
              htmlFor="LastName" 
              className={[label_small, styles.label].join(' ')} 
              aria-hidden={"true"}
            >
              Last Name
            </label>
          </div>

          <div className={field}>
            <input 
              id={'CustomerEmail'}
              ref={emailRef}
              type="email"
              name="customer[email]"
              className={styles.input}
              placeholder="Email"
              spellCheck="false"
              autoComplete="off"
              autoCapitalize="none"
              autoFocus=""
              required="required"
            />
            <label 
              htmlFor="CustomerEmail" 
              className={[label_small, styles.label].join(' ')} 
              aria-hidden={"true"}
            >
              Email
            </label>
          </div>

          <div className={field}>
            <input 
              id={'CustomerPassword'}
              type="password" 
              ref={passRef}
              name="customer[password]" 
              className={styles.input}
              placeholder="Password" 
              required="required"
            />
            <label 
              htmlFor="CustomerPassword" 
              className={[label_small, styles.label].join(' ')} 
              aria-hidden={"true"}
            >
              Password
            </label>
          </div>

          <div className={field}>
            <label 
              htmlFor="AcceptsMarketing" 
              className={`${styles.squarecheck} squarecheck_label`} 
              aria-hidden={"true"}
            >
              <input 
                id={'AcceptsMarketing'}
                type="checkbox" 
                ref={marketRef}
                value={'true'}
                name="customer[accepts_marketing]" 
              />
              <div className="squarecheck_check"></div>
              <span>If you think our clothes look great, you should see our emails </span>
            </label>
          </div>

          <div className={field_submit}>
            <input type="submit" className="btn" value="Create Account" />
          </div>

          <div className={submit_opts}>
            <div className={field}>
              <Flink href={auth_url}>
                Already have an account? Login
              </Flink>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}
export default AcctRegister

export const Head = () => (
  <Seo 
    title={'Create an Account'}
    url={`/account/register`}
  />
)






